import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { ArchiveFilter } from "../../../components/Filter/ArchiveFilter/ArchiveFilter";
import { Loading } from "../../../components/Loading/Loading";
import { TaskModal } from "../../../components/Modal/TaskModal/TaskModal";
import { EDIT_ARCHIVED_TASK, REMOVE_ARCHIVED_TASK } from "../../../constants";
import { ArchiveContext } from "../../../providers/ArchiveContextProvider";
import { ArchiveItems } from "./ArchiveItems/ArchiveItems";
function Archive() {
    const { state: { archivedTasks }, archiveDispatch, } = useContext(ArchiveContext);
    if (!archivedTasks) {
        return _jsx(Loading, { className: "wpqt-h-[200px]" });
    }
    return (_jsxs("div", { children: [_jsx(ArchiveFilter, {}), _jsx(ArchiveItems, {}), _jsx(TaskModal, { editTaskCallback: (task) => {
                    archiveDispatch({
                        type: EDIT_ARCHIVED_TASK,
                        payload: task,
                    });
                }, deleteTaskCallback: (task) => {
                    archiveDispatch({
                        type: REMOVE_ARCHIVED_TASK,
                        payload: task.id,
                    });
                } })] }));
}
export { Archive };
